var exports = {
  "PB": "statsGridContent__5TP_P_",
  "NB": "statsGridItem__xIRlCI",
  "Ky": "fourColumnGridItem__19fTib",
  "zH": "tabletRowStart__5DGaSq",
  "kN": "tabletRowEnd__58is1n",
  "fc": "desktopRowStart__XBNdq5",
  "U6": "desktopRowEnd__dJUrt4",
};

module.exports = exports;
